import { microToPercentWithPrecision } from '@openx/utils/lib/microToPercent.ts';
import type { CuratedDealBuyerDiscountApi } from '../../../../types/curatedDealBuyerDiscount.ts';
import {
  type CuratedDealBuyerDiscountSeat,
  type CuratedDealBuyerDiscountsFormData,
  curatedDealBuyerDiscountApplyTo,
} from '../types.ts';

export const createCuratedDealBuyerDiscountFormData = (
  curatedDealBuyerDiscount: CuratedDealBuyerDiscountApi,
  demandPartnerName: string | null,
  seatById: Record<string, CuratedDealBuyerDiscountSeat>
): CuratedDealBuyerDiscountsFormData => {
  const isAppliedToDemandPartner = typeof curatedDealBuyerDiscount.demand_partner_id === 'string';

  return {
    apply_to: isAppliedToDemandPartner
      ? curatedDealBuyerDiscountApplyTo.DemandPartner
      : curatedDealBuyerDiscountApplyTo.Seats,
    banner_and_video_discount: microToPercentWithPrecision(curatedDealBuyerDiscount.banner_and_video_discount) ?? '',
    ctv_discount: microToPercentWithPrecision(curatedDealBuyerDiscount.ctv_discount) ?? '',
    demand_partner: curatedDealBuyerDiscount.demand_partner_id
      ? {
          id: curatedDealBuyerDiscount.demand_partner_id,
          name: demandPartnerName ?? curatedDealBuyerDiscount.demand_partner_id,
        }
      : null,
    min_one_discount_error: '',
    name: curatedDealBuyerDiscount.name,
    seat_ids: seatById,
  };
};
